import { render, staticRenderFns } from "./housekeepingServ.vue?vue&type=template&id=12700f35&scoped=true"
import script from "./housekeepingServ.vue?vue&type=script&lang=js"
export * from "./housekeepingServ.vue?vue&type=script&lang=js"
import style0 from "./housekeepingServ.vue?vue&type=style&index=0&id=12700f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12700f35",
  null
  
)

export default component.exports